import { render, staticRenderFns } from "./Replicate.vue?vue&type=template&id=3ab67ed4"
import script from "./Replicate.vue?vue&type=script&lang=js"
export * from "./Replicate.vue?vue&type=script&lang=js"
import style0 from "./Replicate.vue?vue&type=style&index=0&id=3ab67ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports